var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-new-plan-modal" }, [
    _c("div", { staticClass: "create-new-plan" }, [
      _c("div", { staticClass: "create-new-plan-form" }, [
        _c(
          "div",
          [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("Settings"),
            ]),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.form.isFreePlan,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "isFreePlan", $$v)
                  },
                  expression: "form.isFreePlan",
                },
              },
              [_vm._v(_vm._s(_vm.$t("billing.freePack")))]
            ),
            _vm._v(" "),
            !_vm.form.isFreePlan
              ? _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.isOnDemand,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isOnDemand", $$v)
                      },
                      expression: "form.isOnDemand",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("billing.instantFee")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.form.isFreePlan
              ? _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.isTeamPlan,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isTeamPlan", $$v)
                      },
                      expression: "form.isTeamPlan",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("billing.teamPackage")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.form.isFreePlan
              ? _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.isAppsumo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isAppsumo", $$v)
                      },
                      expression: "form.isAppsumo",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("billing.appsumoPack")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.form.isFreePlan
              ? _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.isEnterPrise,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isEnterPrise", $$v)
                      },
                      expression: "form.isEnterPrise",
                    },
                  },
                  [_vm._v(" Enter Prise Plan")]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.$t("billing.planSequence"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.form.order,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "order", $$v)
                },
                expression: "form.order",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.isAppsumo
          ? _c(
              "div",
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.requiredCodes"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.requiredCodes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "requiredCodes", $$v)
                    },
                    expression: "form.requiredCodes",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.$t("message.title"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { type: "text" },
              model: {
                value: _vm.form.title,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "title", $$v)
                },
                expression: "form.title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.$t("billing.subHeading"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { type: "text" },
              model: {
                value: _vm.form.altTitle,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "altTitle", $$v)
                },
                expression: "form.altTitle",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.$t("billing.packageType"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              },
              _vm._l(_vm.types, function (type) {
                return _c(
                  "a-select-option",
                  { key: type.key, attrs: { value: type.key } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(type.title) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.form.isEnterPrise &&
        (_vm.form.type === "custom" || _vm.form.type === "feature")
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.form.type === "custom"
                          ? "Custom Paket Key"
                          : _vm.$t("billing.featureKey")
                      ) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { type: "text", placeholder: "whatsapp-broadcast" },
                  model: {
                    value: _vm.form.dynamicType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "dynamicType", $$v)
                    },
                    expression: "form.dynamicType",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Enter Price URL"),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.form.enterPriseUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "enterPriseUrl", $$v)
                    },
                    expression: "form.enterPriseUrl",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.featureKey"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { type: "text", placeholder: "appsumo" },
                  model: {
                    value: _vm.form.partnerKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "partnerKey", $$v)
                    },
                    expression: "form.partnerKey",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan &&
        _vm.form.type !== "automation" &&
        !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.monthlyPrice"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.price,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "price", $$v)
                    },
                    expression: "form.price",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        ["automation", "mail", "web"].includes(_vm.form.type)
          ? _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("Fiyatlandırma"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      { attrs: { ghost: "" }, on: { click: _vm.addPricing } },
                      [_vm._v("Yeni Satır Ekle")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.form.selectFeatures || [],
                  function (selectFeature, index) {
                    return _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "10px",
                          "margin-top": "10px",
                          width: "100%",
                        },
                      },
                      [
                        _c("a-button", {
                          attrs: { type: "danger", icon: "delete" },
                          on: {
                            click: function ($event) {
                              return _vm.removePricing(index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "align-self": "flex-start" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.form.type === "automation"
                                    ? "Otomasyon Kullanımı"
                                    : "Email Kullanımı"
                                ) +
                                "\n                        "
                            ),
                            _c("a-input", {
                              staticClass: "plan-input",
                              attrs: {
                                value: selectFeature.count,
                                min: 0,
                                type: "number",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updatePricing(
                                    index,
                                    $event.target.value,
                                    selectFeature.price
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.type === "mail"
                          ? _c(
                              "div",
                              { staticStyle: { "align-self": "flex-start" } },
                              [
                                _vm._v(
                                  "\n                        Email Kişi Sayısı\n                        "
                                ),
                                _c("a-input", {
                                  staticClass: "plan-input",
                                  attrs: {
                                    value:
                                      selectFeature.details
                                        .uniqEmailContactCount,
                                    min: 0,
                                    type: "number",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateSelectFeatureDetails(
                                        index,
                                        "uniqEmailContactCount",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "align-self": "flex-start" } },
                          [
                            _vm._v(
                              "\n                        Price\n                        "
                            ),
                            _c("a-input", {
                              staticClass: "plan-input",
                              attrs: {
                                value: selectFeature.price,
                                min: 0,
                                type: "number",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updatePricing(
                                    index,
                                    selectFeature.count,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("hr"),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan &&
        _vm.form.type !== "automation" &&
        !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.monthlyNonDiscounted"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.discountPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "discountPrice", $$v)
                    },
                    expression: "form.discountPrice",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan && !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "5px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.twoYearDiscount"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.twoYearDiscount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "twoYearDiscount", $$v)
                    },
                    expression: "form.twoYearDiscount",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan && !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "5px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.yearDisccount"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.yearlyDiscount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "yearlyDiscount", $$v)
                    },
                    expression: "form.yearlyDiscount",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan && !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "5px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.sixMonthDiscount"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.sixMonthlyDiscount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "sixMonthlyDiscount", $$v)
                    },
                    expression: "form.sixMonthlyDiscount",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.form.isFreePlan && !_vm.form.isEnterPrise
          ? _c(
              "div",
              { staticStyle: { "margin-top": "5px" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.threeMonthDiscount"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "plan-input",
                  attrs: { min: 0, type: "number" },
                  model: {
                    value: _vm.form.threeMonthlyDiscount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "threeMonthlyDiscount", $$v)
                    },
                    expression: "form.threeMonthlyDiscount",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "5px" } }, [
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.$t("billing.features"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  on: { select: _vm.onSelectFeaturesForm },
                  model: {
                    value: _vm.featuresForm,
                    callback: function ($$v) {
                      _vm.featuresForm = $$v
                    },
                    expression: "featuresForm",
                  },
                },
                _vm._l(_vm.featureTypes, function (feature) {
                  return _c(
                    "a-select-option",
                    { key: feature.key, attrs: { value: feature.key } },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(feature.title) +
                          "\n                        "
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _vm.features.includes("agent")
                    ? _c("AgentFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("agent")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("archive")
                    ? _c("ArchiveFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("archive")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("chat")
                    ? _c("ChatFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("chat")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("chatbot")
                    ? _c("ChatBotFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("chatbot")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("mail")
                    ? _c("MailFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("mail")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("report")
                    ? _c("ReportFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("report")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("sms")
                    ? _c("SMSFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("sms")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("support")
                    ? _c("SupportFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("support")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("system")
                    ? _c("SystemFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("system")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("team_chat")
                    ? _c("TeamChatFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("team_chat")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("trigger")
                    ? _c("TriggerFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("trigger")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("whatsapp")
                    ? _c("WhatsappFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("whatsapp")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("instagram")
                    ? _c("InstagramFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("instagram")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("messenger")
                    ? _c("MessengerFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("messenger")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("trendyol")
                    ? _c("TrendyolFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("trendyol")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("services")
                    ? _c("ServicesFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("services")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("automation")
                    ? _c("AutomationFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("automation")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("form")
                    ? _c("FormFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("form")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("meta-lead")
                    ? _c("MetaLeadFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("meta-lead")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("customer-tables")
                    ? _c("CustomerTablesFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("customer-tables")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("tasks")
                    ? _c("TaskFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("tasks")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("linkedin")
                    ? _c("LinkedinFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("linkedin")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("telegram")
                    ? _c("TelegramFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("telegram")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("web-traffic")
                    ? _c("WebTrafficFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("web-traffic")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("voice-agent")
                    ? _c("VoiceAgentFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("voice-agent")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.features.includes("webphone")
                    ? _c("WebphoneFeature", {
                        on: {
                          close: function ($event) {
                            return _vm.deleteFeature("webphone")
                          },
                        },
                        model: {
                          value: _vm.form,
                          callback: function ($$v) {
                            _vm.form = $$v
                          },
                          expression: "form",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "create-new-plan-preview" },
        [_c("Card", { attrs: { plan: _vm.planStructure, isReadonly: true } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "create-new-plan-modal-footer" },
      [
        _vm.form._id
          ? _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.updateAction } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n        "
                ),
              ]
            )
          : _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.createAction } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.save")) +
                    "\n        "
                ),
              ]
            ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { ghost: "" }, on: { click: _vm.cancelAction } },
          [_vm._v(_vm._s(_vm.$t("billing.cancelIt")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }